<template>
  <div v-loading="loadingMod">
    <el-header height="200" style="padding-left: 0px">
      <BaseTitleBox title="Edita tu Planificación"
                    subtitle="Edita las rutas de tu planificación seleccionando puntos">
      </BaseTitleBox>
      <div class="rowRoutePatent">
        <i style="font-size: 11px; margin-right: 5px; color: #AAD500;" class="el-icon-view"></i>
        <span class="titleStyle">Seguimiento Nº {{this.idTracing}}</span>
        <i style="font-size: 11px; margin-right: 5px; color: #AAD500;" class="el-icon-position"></i>
        <span class="titleStyle">
          Rutas
          <i v-if="this.tableData.length < 1" class="el-icon-loading"></i>
          <span v-else>{{this.tableData.length}}</span>
        </span>
        <el-button type="text" style="padding: 0px; font-size: 11px;" @click="returnMod()">
          <i class="el-icon-arrow-left"></i>VOLVER
        </el-button>
      </div>
    </el-header>
    <div style="margin-left: 30px; margin-top: 10px;">
      <el-row :gutter=5>
        <el-col :span="8">
          <el-card :body-style="{ padding: '3px' }">
            <div style="height: 530px;">
              <el-table size="mini"
                        height="520"
                        v-loading="tableData.length < 1"
                        tooltip-effect="dark"
                        style="font-size: 10px;"
                        :cell-style="{ padding: '2px'}"
                        ref="multipleTable"
                        :data="tableData"
                        @selection-change="handleSelectionChange">
              <el-table-column type="selection"
                               size="mini"
                               min-width="10">
              </el-table-column>
              <el-table-column property="id"
                               show-overflow-tooltip
                               min-width="60"
                               label="ID">
                <template slot-scope="scope">
                    <p style="font-size: 10px; white-space: nowrap; overflow:hidden;
                    direction: rtl !important;
                    text-overflow: ellipsis;">
                      {{ scope.row.id }}</p>
                </template>
              </el-table-column>
              <el-table-column label="PATENTE"
                                 align="left"
                                 min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.active === false">
                      <EditTruck  :is-editing="isEditing"
                                  :scope="scope"
                                  :editing="editing"
                                  :property="scope.row"
                                  subproperty="patent"
                                  @refresh="reLoad"
                                  @blur-input="onCellBlur"
                                  @enter-input="onCellBlur">
                      </EditTruck>
                    </div>
                    <div v-else>
                      <el-button style="background-color: transparent !important;
                          border: transparent !important; padding: 0px !important;"
                                 type="text" plain disabled>
                        <div style="margin-top: 5px;">
                          <i class="el-icon-truck">
                            <span class="spCla">{{scope.row.vehicle.patent}}</span>
                          </i>
                        </div>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              <el-table-column label="VOL"
                               property="percentaje"
                               show-overflow-tooltip
                               min-width="40">
                <template slot-scope="scope">
                  <span style="font-size: 10px">
                    {{ calculateVolumePercentageRoute(scope.row)}} %
                  </span>
                </template>
              </el-table-column>
              <el-table-column  label="SOC" :min-width="50" align="center">
                  <template slot-scope="scope">
                    <el-button  size="mini"
                                type="text"
                                @click="selectedAllPoint(scope.row)">
                      <span v-if="scope.row.delivery_points">
                        <!-- eslint-disable -->
                        <i v-if="selectedMarkId.filter(data => data.routeId === scope.row.id).length === scope.row.delivery_points.length"
                           style="color: #F5A623; font-size: 11px; font-weight: bold">
                          {{ scope.row.delivery_points ? scope.row.delivery_points.length : 0}}</i>
                        <i v-else style="color: #AAD500; font-size: 11px;">
                          {{ scope.row.delivery_points ? scope.row.delivery_points.length : 0 }}</i>
                      </span>
                      <span v-else>
                        <i style="color: #a5a5a5; font-size: 11px;">
                          {{ scope.row.delivery_points ? scope.row.delivery_points.length : 0 }}</i>
                      </span>
                    </el-button>
                  </template>
                </el-table-column>
              <el-table-column property="tim"
                                 show-overflow-tooltip
                                 min-width="40"
                                 label="TIM">
                  <template slot-scope="scope">
                    <el-button  v-if="scope.row.active === false"
                                type="text"
                                style="color: #AAD500"
                                @click="dialogEditS(scope.row)">
                      <i style="font-size: 15px" class="el-icon-edit"></i>
                    </el-button>
                    <el-button  v-else
                                type="text"
                                style="background-color: transparent !important;
                              border: transparent !important; padding: 0px !important;"
                                disabled>
                      <i style="font-size: 15px" class="el-icon-edit"></i>
                    </el-button>
                  </template>
                </el-table-column>
              <el-table-column label="REP" property="modified" min-width="46">
                  <template slot-scope="scope" style="text-align: center;">
                    <span v-if="!scope.row.active && scope.row.modified">
                      <el-button v-if="scope.row.replanning_state === 0"
                                 slot="reference"
                                 style="background-color: transparent !important;
                               border: transparent; font-size: 20px; padding: 0;"
                                 type="text"
                                 plain
                                 v-model="scope.row.modified"
                                 @click="changeReplanning(scope.row)">
                        <i class="el-icon-refresh-right refresh-send"/>
                      </el-button>
                      <i v-else-if="scope.row.replanning_state === 1"
                         slot="reference"
                         class="el-icon-loading"
                         style="font-size: 15px;"/>
                      <i v-else-if="scope.row.replanning_state === 2"
                         slot="reference"
                         class="el-icon-refresh-right rotate-1"
                         style="font-size: 15px;"/>
                    </span>
                    <div v-else style="text-align: center">—</div>
                  </template>
                </el-table-column>
              <el-table-column
                label="ESTADO"
                min-width="60">
                <el-switch
                  slot-scope="scope"
                  @change="changeStatusRoutes(scope.row)"
                  style="width: 30px;"
                  v-model="scope.row.active"
                  active-color="#AAD500"
                  inactive-color="#c0c4cc">
                </el-switch>
              </el-table-column>
            </el-table>
          </div>
          </el-card>
        </el-col>
        <el-col :span="10">
          <FilterMap  :open="viewRouteForm">
            <MapRoutesMultiple slot="map"
                             ref="mapRoute"
                             :height="'540px'"
                             :width="'100%'"
                             :scrollWheel="false"
                             :locations="routes"
                             @selectedPoint="selectedPoint"
                             @selectedPointAll="selectedPointAll">
            </MapRoutesMultiple>
          </FilterMap>
        </el-col>
        <el-col :span="5">
          <el-card :body-style="{ padding: '3px' }">
            <div style="height: 530px;">
            <el-table
              size="mini"
              height="345"
              tooltip-effect="dark"
              :cell-style="{ padding: '2px'}"
              :empty-text = "slot='Selecciona puntos de ruta'"
              :data="selectedMarkId"
              style="width: 100%; font-size: 10px;">
              <el-table-column label="ID"
                               min-width="60"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <p style="font-size: 10px; white-space: nowrap; overflow:hidden;
                      direction: rtl !important;
                      text-overflow: ellipsis;">
                    {{ scope.row.routeId }}</p>
                </template>
              </el-table-column>
              <el-table-column label="GEO"
                               align="left"
                               min-width="45"
                               property="geo_state_id">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.geo_states_id === 4 ? 'primary' : 'success'"
                          disable-transitions>{{scope.row.geo_states_id}}
                  </el-tag>
                </template>
                <template slot-scope="scope">
                    <span v-if="scope.row.geo_states_id === 4"
                          class="fa-stack fa-2x clickeable"
                          @click="linkBlanck(scope.row.id)">
                      <i class="fas fa-map-marked-alt fa-stack-2x"></i>
                      <i class="fas fa-map-marker-alt fa-stack-1x point-map"></i>
                    </span>
                    <span v-else @click="linkBlanck(scope.row.id)">
                        <i class="el-icon-edit" style="font-size: 14px; color: #AAD500;"></i>
                    </span>
                </template>
              </el-table-column>
              <el-table-column property="patent"
                               show-overflow-tooltip
                               label="PATENTE" min-width="80">
              </el-table-column>
              <el-table-column property="id"
                               label="SOC"
                               min-width="100"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column property="total_volumen"
                               label="VOLUMEN"
                               show-overflow-tooltip
                               min-width="100">
                <span slot-scope="scope">{{scope.row.total_volumen | truncateDecimal}} mt³</span>
              </el-table-column>
              <el-table-column property="document_type"
                               label="TIPO"
                               show-overflow-tooltip
                               min-width="130">
              </el-table-column>
              <el-table-column property="requested_at"
                               label="F. PACTADA"
                               show-overflow-tooltip
                               min-width="100">
                <span slot-scope="scope">{{scope.row.requested_at | formatDate}}</span>
              </el-table-column>
              <el-table-column property="raw_address"
                               label="LOCALIDAD"
                               show-overflow-tooltip
                               min-width="100">
                <span slot-scope="scope">{{scope.row.locality.toUpperCase()}}</span>
              </el-table-column>
              <el-table-column property="raw_address"
                               label="DIRECCIÓN"
                               show-overflow-tooltip
                               min-width="100">
                <span slot-scope="scope">{{scope.row.raw_address.toUpperCase()}}</span>
              </el-table-column>
            </el-table>
            <el-select v-model="value" @change="selectedPatent"
                       clearable
                       style="width: 230px; margin-top: 13px;"
                       placeholder="SELECCIONA PATENTE">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <p style="color: #a5a5a5; font-size: 12px; margin-bottom: 2px">
              CAPACIDAD OCUPADA VEHÍCULO</p>
            <el-progress :percentage="percentageVehicle"
                         :stroke-width="10"
                         style="width: 240px; display: inline-block; margin-bottom: 8px;">
            </el-progress>
            <p v-show="percentageV > 100"
               style="color: #F5A623; font-size: 12px; margin-top: 5px;">
              EXCEDES LA CAPACIDAD DEL VEHÍCULO
            </p>
            <el-button type="primary" @click="confirmSend()">MODIFICAR PLANIFICACIÓN
            </el-button>
          </div>
          </el-card>
        </el-col>
        <el-dialog :visible.sync="resultMod">
          <h3 class="dialogTitle">
            <i class="el-icon-edit" aria-hidden="true"></i>RESULTADO MODIFICACIÓN</h3>
          <span class="dialogTitle">
        </span>
          <div v-if="remOK === '' && addOK === ''">
            <div class="dialogError"><i class="el-icon-error"></i>ERROR AL MODIFICAR LA RUTA</div>
          </div>
          <div v-if="airAdd === 'OK' || orAdd === 'OK' || nfAdd === 'OK'" class="dialogSub">
            <i class="el-icon-circle-plus"></i>ERROR AL AGREGAR</div>
          <div class="dialogItem"
               v-if="notFoundAdd.length > 0">
            <span class="totalItemTim">{{notFoundAdd.length}}</span> NO ENCONTRADAS
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(notFoundA, index) in notFoundAdd"
                  :key="index.notFoundAdd">{{notFoundA}}
              </li>
            </ol>
          </div>
          <div class="dialogItem"
               v-if="addFailOtherRoutes.length > 0">
            <span class="totalItemTim">{{addFailOtherRoutes.length}}</span> EN OTRA RUTA
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(addFailOtherRoutesA, index) in addFailOtherRoutes"
                  :key="index.addFailOtherRoutes">{{addFailOtherRoutesA}}
              </li>
            </ol>
          </div>
          <div class="dialogItem"
               v-if="addAlreadyInRoute.length > 0">
            <span class="totalItemTim">{{addAlreadyInRoute.length}}</span> EN RUTA
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(addAlreadyInRouteA, index) in addAlreadyInRoute"
                  :key="index.addAlreadyInRoute">{{addAlreadyInRouteA}}
              </li>
            </ol>
          </div>
          <div class="dialogSub" v-if="ntRem === 'OK' || iorRem === 'OK'">
            <i class="el-icon-remove"></i>ERROR AL ELIMINAR</div>
          <div class="dialogItem"
               v-if="notFoundDelete.length > 0">
            <span class="totalItemTim">{{notFoundDelete.length}}</span> NO ENCONTRADAS
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(notFoundDeleteA, index) in notFoundDelete"
                  :key="index.notFoundDelete">{{notFoundDeleteA}}
              </li>
            </ol>
          </div>
          <div class="dialogItem" v-if="deleteFailOtherRoutes.length > 0">
            <span class="totalItemTim">{{deleteFailOtherRoutes.length}}</span> EN OTRA RUTA
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(deleteFailOtherRoutesA, index) in deleteFailOtherRoutes"
                  :key="index.deleteFailOtherRoutes">{{deleteFailOtherRoutesA}}
              </li>
            </ol>
          </div>
          <div v-if="Array.isArray(addSuccess)">
            <div class="dialogSub"><i class="el-icon-success"></i>SOC AGREGADAS CON ÉXITO
              <span class="totalItemTimSuss">{{addSuccess.length}}</span>
            </div>
            <ol class="dialogItemSuss">
              <li type="none" v-for="(addSuccessA, index) in addSuccess"
                  :key="index.addSuccess">{{addSuccessA}}
              </li>
            </ol>
          </div>
          <div v-if="Array.isArray(deleteSuccess)">
            <div class="dialogSub"><i class="el-icon-success"></i>SOC ELIMINADAS CON ÉXITO
              <span class="totalItemTimSuss">{{deleteSuccess.length}}</span>
            </div>
            <ol class="dialogItemSuss">
              <li type="none" v-for="(deleteSuccessA, index) in deleteSuccess"
                  :key="index.deleteSuccess">{{deleteSuccessA}}
              </li>
            </ol>
          </div>
          <p></p>
          <p v-show="addOK === 'OK' || remOK === 'OK'"
             class="dialogRec">Recuerda replanificar tu Ruta</p>
        </el-dialog>
        <el-dialog :visible.sync="dialogEditSoc"
                   @closed="closeDialogTabs"
                   width="50%" style="height: 600px;">
          <h5 class="dialogTitle">
            <i class="el-icon-edit" aria-hidden="true"></i>
            PATENTE {{vehicle}}
          </h5>
          <el-tabs type="border-card" @tab-click="tabClick" value="tim">
            <el-tab-pane label="TIM" name="tim">
              <el-input type="textarea"
                        :rows="6"
                        placeholder="EJEMPLO TIM: 124005957777, 124005958888, 124005959999 ..."
                        v-model="textareaTim">
              </el-input>
            </el-tab-pane>
            <el-tab-pane label="AGREGAR" name="add">
              <el-input type="textarea"
                        :rows="6"
                        placeholder="EJEMPLO AGREGAR: 124005957704, 124005957705, 124005957706..."
                        v-model="textareaAdd">
              </el-input>
            </el-tab-pane>
            <el-tab-pane label="ELIMINAR" name="del">
              <el-input type="textarea"
                        :rows="6"
                        placeholder="EJEMPLO ELIMINAR: 124005957704, 124005957705..."
                        v-model="textareaDel">
              </el-input>
            </el-tab-pane>
          </el-tabs>
          <span slot="footer" class="dialog-footer">
            <el-button  v-if="button.showTim" class="btn primary"
                        size="mini"
                        @click="checkOrders('tim')"
                        style="height: 30px; width: 120px;">Modificar
            </el-button>
            <el-button  v-if="button.showAdd" class="btn primary"
                        size="mini"
                        @click="checkOrders('add')"
                        style="height: 30px; width: 120px;">Agregar
            </el-button>
            <el-button  v-if="button.showDel" class="btn primary"
                        size="mini"
                        @click="checkOrders('del')"
                        style="height: 30px; width: 120px;">Eliminar
            </el-button>
          </span>
        </el-dialog>
        <el-dialog :visible.sync="dialog.checkOrder">
          <h3 class="dialogTitle">
            <i class="el-icon-warning" aria-hidden="true"></i>REVISA LAS SOC A MODIFICAR
          </h3>
          <div class="dialogSub" v-if="ordersToAdd.length > 0">
            <p><i class="el-icon-circle-plus"></i>SOC A AGREGAR
              <span class="totalItemTimSuss">{{ordersToAdd.length}}</span>
            </p>
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(orderAdd, index) in ordersToAdd" :key="index.ordersToAdd">
                {{orderAdd}}
              </li>
            </ol>
          </div>
          <div class="dialogSub" v-if="ordersToDelete.length > 0">
            <p><i class="el-icon-remove"></i>SOC A ELIMINAR
              <span class="totalItemTimSuss">{{ordersToDelete.length}}</span>
            </p>
            <ol class="ordersListStyleDialog">
              <li type="none" v-for="(orderDelete, index) in ordersToDelete"
                  :key="index.ordersToDelete">{{orderDelete}}
              </li>
            </ol>
          </div>
          <p class="dialogText">Esta modificación puede afectar el ETA propuesto inicialmente.
            <span class="focus">¿Quieres modificar la Ruta?</span>
          </p>
          <span slot="footer" class="dialog-footer">
        <el-button class="btn grey" @click="cancelModSoc()">CANCELAR</el-button>
        <el-button class="btn primary btnSearch" @click="addOrderSoc()">ACEPTAR</el-button>
      </span>
        </el-dialog>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import EditTruck from './EditTruck.vue';
import BaseTitleBox from './BaseBoxTitle.vue';
import { apiRequest } from '../../backend/vue-axios/axios';
import FilterMap from './maps/FilterMap.vue';
import MapRoutesMultiple from './maps/MapRoutesMultiple.vue';
import { manageSession, geoUpdateHandlerEditRoutes } from '../../mixins/manageSession';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';

export default {
  name: 'PlanningEditRoutes',
  props: ['idRoute', 'patent', 'idTracing'],
  components: {
    BaseTitleBox,
    FilterMap,
    MapRoutesMultiple,
    EditTruck,
  },
  data() {
    return {
      activeRoutes: true,
      editing: null,
      loadingMod: false,
      routes: [],
      volumeSelected: 0,
      percentageVehicle: 0,
      filter: {
        route_id: null,
        code: null,
        limit: 1000,
      },
      tableData: [],
      multipleSelection: [],
      options: [],
      value: '',
      selectedMarkId: [],
      viewRouteForm: false,
      selectedId: [],
      listCodeSoc: [],
      notFoundAdd: [],
      notFoundDelete: [],
      addSuccess: [],
      loadMap: false,
      deleteSuccess: [],
      addFailOtherRoutes: [],
      deleteFailOtherRoutes: [],
      addAlreadyInRoute: [],
      addError: false,
      deleteError: false,
      totalSocTim: 0,
      resultMod: false,
      remOK: '',
      addOK: '',
      airAdd: '',
      orAdd: '',
      nfAdd: '',
      ntRem: '',
      iorRem: '',
      messageRoutesActives: 0,
      vehicle: '',
      dialogEditSoc: false,
      button: {
        showTim: true,
        showAdd: false,
        showDel: false,
      },
      textareaTim: '',
      textareaAdd: '',
      textareaDel: '',
      ordersToAdd: [],
      ordersToDelete: [],
      ordersToTim: [],
      orders: [],
      ordersToEdit: {
        add_suborders: [],
        remove_suborders: [],
      },
      totalSoc: null,
      totalPackages: null,
      totalPoints: null,
      formFilter: {
        code: null,
      },
      subOrderList: [],
      searchSoc: '',
      subOrderListDetails: [],
      subordersChange: '',
      dialog: {
        checkOrder: false,
      },
      loadingTable: false,
      idRouteModSoc: '',
      percentageV: 0,
    };
  },
  filters: {
    truncateDecimal(number) {
      const t = number.toString();
      const regex = /(\d*.\d{0,4})/;
      return t.match(regex)[0];
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
  },
  computed: {
    isEditing() {
      return this.editing !== null;
    },
  },
  methods: {
    reLoad() {
      this.searchTracing(this.idTracing);
    },
    onCellBlur() {
      this.editing = null;
    },
    returnMod() {
      if (this.$route.params.v > 0) {
        const querys = {};
        const parameter = {};
        if (this.$route.params.v === 1) {
          querys.distribution_centers_id = this.$route.params.distribution_centers_id;
          parameter.v = 1;
        }
        if (this.$route.params.v === 2) {
          querys.enterprise_id = this.$route.params.enterprise_id;
          parameter.v = 2;
        }
        if (this.$route.params.v === 3) {
          querys.enterprise_id = this.$route.params.enterprise_id;
          querys.distribution_centers_id = this.$route.params.distribution_centers_id;
          parameter.v = 3;
        }
        this.$router.push({
          name: 'Status',
          query: querys,
          params: parameter,
        });
      } else {
        this.$router.push({
          name: 'Status',
          params: { v: 0 },
        });
      }
    },
    changeStatusRoutes(row) {
      if (row.delivery_points !== null) {
        if (row.active) {
          this.$confirm('¿Quieres activar la ruta?', 'Confirmación', {
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            type: 'warning',
          }).then(() => {
            const startedAt = startRumTiming();
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation',
              action: 'activation_requested',
              status: 'attempt',
              context: {
                route_id: row.id,
                source: 'planning_edit_routes',
                tracing_id: this.idTracing,
              },
            });
            const messageActive = this.$message({
              message: `Activando Ruta ${row.id}, espera un momento por favor`,
              duration: 0,
              showClose: true,
            });
            apiRequest({
              module: 'planning',
              service: 'activate_route',
              pathparam: { id: row.id },
              params: { id: row.id },
            }).then((res) => {
              this.$notify({
                type: 'success',
                title: 'ACTIVACIÓN REALIZADA',
                message: `Ruta Nº ${res.data.id} activada`,
              });
              trackBusinessFlow({
                module: 'planning',
                flow: 'route_activation',
                action: 'activation_completed',
                status: 'success',
                durationMs: getRumDuration(startedAt),
                context: {
                  route_id: row.id,
                  source: 'planning_edit_routes',
                  tracing_id: this.idTracing,
                },
              });
              const routeSelected = this.tableData.filter(route => route.id === row.id);
              routeSelected[0].active = true;
              messageActive.close();
            }).catch((error) => {
              trackBusinessFlow({
                module: 'planning',
                flow: 'route_activation',
                action: 'activation_completed',
                status: 'error',
                durationMs: getRumDuration(startedAt),
                context: {
                  route_id: row.id,
                  source: 'planning_edit_routes',
                  tracing_id: this.idTracing,
                  error_status: error.response ? error.response.status : null,
                },
              });
              if (error.response) {
                this.$notify({
                  type: 'error',
                  title: 'Error',
                  message: error.response.data.message,
                });
              }
              const routeSelected = this.tableData.filter(route => route.id === row.id);
              routeSelected[0].active = false;
              messageActive.close();
            });
          }).catch(() => {
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation',
              action: 'activation_cancelled',
              status: 'cancelled',
              context: {
                route_id: row.id,
                source: 'planning_edit_routes',
                tracing_id: this.idTracing,
              },
            });
            const routeSelected = this.tableData.filter(route => route.id === row.id);
            routeSelected[0].active = false;
          });
        } else {
          this.$confirm('¿Quieres desactivar la ruta?', 'Confirmación', {
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            type: 'warning',
          }).then(() => {
            const startedAt = startRumTiming();
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation',
              action: 'deactivation_requested',
              status: 'attempt',
              context: {
                route_id: row.id,
                source: 'planning_edit_routes',
                tracing_id: this.idTracing,
              },
            });
            const messageDeactive = this.$message({
              message: `Desactivando Ruta ${row.id}, espera un momento por favor`,
              duration: 0,
              showClose: true,
            });
            apiRequest({
              module: 'planning',
              service: 'deactivate_route',
              pathparam: { id: row.id },
              params: { id: row.id },
            }).then((res) => {
              this.$notify({
                type: 'success',
                title: 'DESACTIVACIÓN REALIZADA',
                message: `Ruta Nº ${res.data.id} desactivada`,
              });
              trackBusinessFlow({
                module: 'planning',
                flow: 'route_activation',
                action: 'deactivation_completed',
                status: 'success',
                durationMs: getRumDuration(startedAt),
                context: {
                  route_id: row.id,
                  source: 'planning_edit_routes',
                  tracing_id: this.idTracing,
                },
              });
              const routeSelected = this.tableData.filter(route => route.id === row.id);
              routeSelected[0].active = false;
              messageDeactive.close();
            }).catch((error) => {
              trackBusinessFlow({
                module: 'planning',
                flow: 'route_activation',
                action: 'deactivation_completed',
                status: 'error',
                durationMs: getRumDuration(startedAt),
                context: {
                  route_id: row.id,
                  source: 'planning_edit_routes',
                  tracing_id: this.idTracing,
                  error_status: error.response ? error.response.status : null,
                },
              });
              if (error.response) {
                this.$notify({
                  type: 'error',
                  title: 'Error',
                  message: error.response.data.message,
                });
              }
              const routeSelected = this.tableData.filter(route => route.id === row.id);
              routeSelected[0].active = true;
              messageDeactive.close();
            });
          }).catch(() => {
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation',
              action: 'deactivation_cancelled',
              status: 'cancelled',
              context: {
                route_id: row.id,
                source: 'planning_edit_routes',
                tracing_id: this.idTracing,
              },
            });
            const routeSelected = this.tableData.filter(route => route.id === row.id);
            routeSelected[0].active = true;
          });
        }
      } else {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_activation',
          action: 'activation_blocked',
          status: 'blocked',
          context: {
            route_id: row.id,
            source: 'planning_edit_routes',
            tracing_id: this.idTracing,
            reason: 'empty_route',
          },
        });
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: 'No se puede activar una ruta con 0 soc',
        });
        const routeSelected = this.tableData.filter(route => route.id === row.id);
        routeSelected[0].active = false;
      }
    },
    changeReplanning(row) {
      if (row.delivery_points) {
        if (row.delivery_points.length > 200 && row.vehicle.enterprise.name !== 'TRANSPORTES TREN LOGISTICO') {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_replanning',
            action: 'replanning_blocked',
            status: 'blocked',
            context: {
              route_id: row.id,
              source: 'planning_edit_routes',
              tracing_id: this.idTracing,
              delivery_points: row.delivery_points.length,
              reason: 'too_many_suborders',
            },
          });
          this.$notify({
            type: 'warning',
            title: 'La ruta no se puede replanificar',
            message: 'Asegúrece de no superar las 200 socs',
          });
        } else {
          this.$confirm('¿Estas seguro que quieres replanificar tu ruta?', 'Confirma tu Replanificación', {
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            type: 'warning',
          }).then(() => {
            const startedAt = startRumTiming();
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_replanning',
              action: 'replanning_requested',
              status: 'attempt',
              context: {
                route_id: row.id,
                source: 'planning_edit_routes',
                tracing_id: this.idTracing,
                delivery_points: row.delivery_points.length,
              },
            });
            const messageReplanning = this.$message({
              message: `Replanificando Ruta ${row.id}, espera un momento por favor`,
              showClose: true,
              duration: 0,
            });
            apiRequest({
              module: 'planning',
              service: 'replanning_route',
              pathparam: { id: row.id },
              params: { id: row.id },
            }).then((res) => {
              this.$notify({
                type: 'success',
                title: 'REPLANIFICACIÓN ACEPTADA',
                message: `Ruta Nº ${res.data.id} en espera...`,
              });
              trackBusinessFlow({
                module: 'planning',
                flow: 'route_replanning',
                action: 'replanning_completed',
                status: 'success',
                durationMs: getRumDuration(startedAt),
                context: {
                  route_id: row.id,
                  source: 'planning_edit_routes',
                  tracing_id: this.idTracing,
                },
              });
              this.searchTracing(this.idTracing);
              messageReplanning.close();
            }).catch((error) => {
              trackBusinessFlow({
                module: 'planning',
                flow: 'route_replanning',
                action: 'replanning_completed',
                status: error.response && error.response.status === 504 ? 'timeout' : 'error',
                durationMs: getRumDuration(startedAt),
                context: {
                  route_id: row.id,
                  source: 'planning_edit_routes',
                  tracing_id: this.idTracing,
                  error_status: error.response ? error.response.status : null,
                },
              });
              if (error.response !== undefined) {
                if (error.response.status === 504) {
                  this.$notify({
                    type: 'warning',
                    showClose: true,
                    title: 'INFO',
                    message: 'Revisa el Seguimiento de procesos background ingresando a INFO COD:504',
                  });
                  messageReplanning.close();
                } else {
                  if (error.response.status > 400 && error.response.status < 500) {
                    this.$notify({
                      type: 'warning',
                      title: 'Planificación en proceso',
                      showClose: true,
                      message: error.response.data.message,
                    });
                  } else {
                    this.$notify({
                      type: 'error',
                      title: 'Error',
                      showClose: true,
                      message: error.response.data.message,
                    });
                  }
                  messageReplanning.close();
                }
              } else {
                messageReplanning.close();
              }
            });
          }).catch(() => {
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_replanning',
              action: 'replanning_cancelled',
              status: 'cancelled',
              context: {
                route_id: row.id,
                source: 'planning_edit_routes',
                tracing_id: this.idTracing,
              },
            });
          });
        }
      } else {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_replanning',
          action: 'replanning_blocked',
          status: 'blocked',
          context: {
            route_id: row.id,
            source: 'planning_edit_routes',
            tracing_id: this.idTracing,
            reason: 'empty_route',
          },
        });
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: 'No se puede replanificar una ruta con 0 soc',
        });
      }
    },
    confirmSend() {
      const selectedArray = [];
      for (let i = 0; i < this.selectedMarkId.length; i += 1) {
        selectedArray.push(this.selectedMarkId[i].id);
        this.ordersToEdit.add_suborders.push(this.selectedMarkId[i].id);
      }
      this.addOrder(this.ordersToEdit);
    },
    selectedPatent(a) {
      if (a !== '') {
        this.calculateVolumePercentage();
      } else {
        this.percentageVehicle = 0;
      }
    },
    calculateVolumePercentageRoute(row) {
      let percentaje = 0;
      if (row.delivery_points !== null) {
        // eslint-disable-next-line
        const totalVol = row.delivery_points.reduce((t, {total_volumen}) => t + total_volumen, 0);
        // eslint-disable-next-line
        percentaje = Math.round(((totalVol) * 100) / row.vehicle_total_capacity);
      }
      return percentaje;
    },
    calculateVolumePercentage() {
      if (this.value !== '') {
        const route = this.tableData.find(e => e.id === this.value);
        if (route.delivery_points === null) {
          const totalVolN = 0;
          // eslint-disable-next-line
          this.percentageVehicle = Math.round(((this.volumeSelected + totalVolN) * 100) / route.vehicle_total_capacity);
        } else {
          // eslint-disable-next-line
          const totalVol = route.delivery_points.reduce((t, {total_volumen}) => t + total_volumen, 0);
          // eslint-disable-next-line
          this.percentageVehicle = Math.round(((this.volumeSelected + totalVol) * 100) / route.vehicle_total_capacity);
        }
        this.validatePercentage(this.percentageVehicle);
      }
    },
    validatePercentage(percentage) {
      this.percentageV = percentage;
      if (percentage > 100) {
        const exc = percentage - 100;
        this.percentageVehicle = 100;
        this.$message({
          title: 'Advertencia',
          message: `EXCEDES LA CAPACIDAD DEL VEHÍCULO EN UN ${exc}%`,
          type: 'warning',
          duration: 10000,
        });
      }
    },
    addOrder() {
      this.loadingMod = true;
      apiRequest(
        {
          module: 'planning',
          service: 'addanddelete_suborders',
          pathparam: { id: this.value },
          params: this.ordersToEdit,
        },
      ).then((res) => {
        this.ordersToEdit.add_suborders = [];
        this.ordersToEdit.remove_suborders = [];
        this.loadingMod = false;
        this.$notify({
          type: 'success',
          title: 'PLANIFICACIÓN MODIFICADA',
          message: 'Rutas modificadas',
        });
        this.value = '';
        this.options = [];
        this.searchTracing(this.idTracing);
        this.resAddOrders(res);
        this.percentageVehicle = 0;
      }).catch((error) => {
        if (error.response) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: error.response.data.message,
          });
        }
        this.loadingMod = false;
        this.percentageVehicle = 0;
      });
    },
    resAddOrders(res) {
      this.resultMod = true;
      if (res.data.add_suborders) {
        // eslint-disable-next-line
        if (res.data.add_suborders['not_found']) {
          this.notFoundAdd = res.data.add_suborders.not_found;
          this.nfAdd = 'OK';
        } else {
          this.notFoundAdd = [];
        }
        // eslint-disable-next-line
        if (res.data.add_suborders['is_in_other_route']) {
          this.addFailOtherRoutes = res.data.add_suborders.is_in_other_route;
          this.orAdd = 'OK';
        } else {
          this.addFailOtherRoutes = [];
        }
        // eslint-disable-next-line
        if (res.data.add_suborders['already_in_route']) {
          this.addAlreadyInRoute = res.data.add_suborders.already_in_route;
          this.airAdd = 'OK';
        } else {
          this.addAlreadyInRoute = [];
        }
      }
      if (res.data.remove_suborders) {
        // eslint-disable-next-line
        if (res.data.remove_suborders['not_found']) {
          this.notFoundDelete = res.data.remove_suborders.not_found;
          this.ntRem = 'OK';
        } else {
          this.notFoundDelete = [];
        }
        // eslint-disable-next-line
        if (res.data.remove_suborders['is_in_other_route']) {
          this.deleteFailOtherRoutes = res.data.remove_suborders.is_in_other_route;
          this.iorRem = 'OK';
        } else {
          this.deleteFailOtherRoutes = [];
        }
      }
      if (Array.isArray(res.data.add_success)) {
        this.addSuccess = res.data.add_success;
        this.addOK = 'OK';
      } else {
        this.addSuccess = null;
      }
      if (Array.isArray(res.data.remove_success)) {
        this.deleteSuccess = res.data.remove_success;
        this.remOK = 'OK';
      } else {
        this.deleteSuccess = null;
      }
      this.totalSocTim = this.ordersToTim.length;
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      /*
      if (this.currentRow != null) {
        this.$refs.mapRoute.selectedPoint(this.currentRow.code);
      }
      */
    },
    // eslint-disable-next-line
    selectedPoint(id, routesId, patent, totalVolumen, pointKey, documentType, requestedAt, rawAddress, locality, geoStates) {
      const isSelected = this.selectedMarkId.filter(data => data.id === id);
      if (isSelected.length > 0) {
        this.selectedMarkId = this.selectedMarkId.filter(ele => ele.id !== id);
        this.$refs.mapRoute.selectedPoint(id, false);
      } else {
        const point = {};
        // eslint-disable-next-line
        point["id"] = id;
        // eslint-disable-next-line
        point["routeId"] = routesId;
        // eslint-disable-next-line
        point["patent"] = patent;
        // eslint-disable-next-line
        point["total_volumen"] = totalVolumen;
        // eslint-disable-next-line
        point["pointKey"] = pointKey;
        // eslint-disable-next-line
        point["document_type"] = documentType;
        // eslint-disable-next-line
        point["requested_at"] = requestedAt;
        // eslint-disable-next-line
        point["raw_address"] = rawAddress;
        // eslint-disable-next-line
        point["locality"] = locality;
        // eslint-disable-next-line
        point["geo_states_id"] = geoStates;
        this.selectedMarkId.push(point);
        this.$refs.mapRoute.selectedPoint(point.id, true);
      }
      this.selectedMarkId = this.selectedMarkId.sort((a, b) => {
        if (a.routeId > b.routeId) {
          return 1;
        }
        if (a.routeId < b.routeId) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      // eslint-disable-next-line
      this.volumeSelected = this.selectedMarkId.reduce((t, {total_volumen}) => t + total_volumen, 0);
      this.calculateVolumePercentage();
    },
    selectedAllPoint(row) {
      const point = row.delivery_points.length;
      const isSelected = this.selectedMarkId.filter(data => data.routeId === row.id);
      if (isSelected.length === point) {
        this.$refs.mapRoute.selectedAllPoint(row.id, false);
      } else {
        this.$refs.mapRoute.selectedAllPoint(row.id, true);
      }
      this.calculateVolumePercentage();
    },
    selectedPointAll(routeId, selectedCodes) {
      this.selectedMarkId = this.selectedMarkId.filter(ele => ele.routeId !== routeId);
      selectedCodes.forEach((element) => {
        const point = {};
        // eslint-disable-next-line
        point["id"] = element.code;
        // eslint-disable-next-line
        point["routeId"] = element.routesId;
        // eslint-disable-next-line
        point["patent"] = element.patent;
        // eslint-disable-next-line
        point["total_volumen"] = element.total_volumen;
        // eslint-disable-next-line
        point["pointKey"] = element.pointKey;
        // eslint-disable-next-line
        point["document_type"] = element.document_type;
        // eslint-disable-next-line
        point["requested_at"] = element.requested_at;
        // eslint-disable-next-line
        point["raw_address"] = element.raw_address;
        // eslint-disable-next-line
        point["locality"] = element.locality;
        // eslint-disable-next-line
        point["geo_states_id"] = element.geo_states_id;
        this.selectedMarkId.push(point);
      });
      // eslint-disable-next-line
      this.volumeSelected = this.selectedMarkId.reduce((t, {total_volumen}) => t + total_volumen, 0);
      this.calculateVolumePercentage();
    },
    handleSelectionChange(data) {
      this.selectedMarkId = [];
      this.routes = data;
    },
    linkBlanck(sub) {
      const routeData = this.$router.resolve({ name: 'Geocode', query: { v: 'fromSubs' } });
      sessionStorage.setItem('suborders', JSON.stringify([sub]));
      manageSession();
      window.name = 'geosortMain';
      this.newPage = window.open(routeData.href, 'geocode');
      // window.close();
    },
    filterStatus(value, row) {
      return row.geostate === value;
    },
    searchTracing(tracingId) {
      this.loadingMod = false;
      const startedAt = startRumTiming();
      apiRequest({
        module: 'planning',
        service: 'get_routes_multiple',
        pathparam: { id: tracingId },
      }).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.tableData = response.data;
          this.tableData.forEach((element) => {
            const optionValue = {};
            if (element.active !== true) {
              // eslint-disable-next-line
              optionValue["value"] = element.id;
              // eslint-disable-next-line
              optionValue["label"] = element.vehicle.patent;
              this.options.push(optionValue);
            } else {
              this.messageRoutesActives += 1;
            }
            if (this.messageRoutesActives === 1 && this.activeRoutes) {
              this.activeRoutes = false;
              this.$message({
                message: 'La planificación tiene rutas activas que no pueden ser modificadas.',
                type: 'warning',
              });
            }
          });
        }
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing',
          action: 'routes_loaded',
          status: response.data.length === 0 ? 'empty' : 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: tracingId,
            source: 'planning_edit_routes',
            routes_count: response.data.length,
          },
        });
        this.loadingMod = false;
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing',
          action: 'routes_loaded',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: tracingId,
            source: 'planning_edit_routes',
          },
        });
        this.$message.error('Hubo un error al obtener las rutas');
        this.loadingMod = false;
      });
    },
    tabClick(tab) {
      if (tab.name === 'tim') {
        this.button.showTim = true;
        this.button.showAdd = false;
        this.button.showDel = false;
      }
      if (tab.name === 'add') {
        this.button.showTim = false;
        this.button.showAdd = true;
        this.button.showDel = false;
      }
      if (tab.name === 'del') {
        this.button.showTim = false;
        this.button.showAdd = false;
        this.button.showDel = true;
      }
    },
    dialogEditS(row) {
      this.subOrderList = [];
      this.dialogEditSoc = true;
      this.idRouteModSoc = row.id;
      this.vehicle = row.vehicle.patent;
      const dp = row.delivery_points;
      dp.forEach((element) => {
        element.suborders.forEach((sub) => {
          const soc = sub;
          this.subOrderList.push(soc);
        });
      });
    },
    checkOrders(commandType) {
      this.dialogEditSoc = false;
      const ordersError = [];
      this.cleanOrdersTo();
      let withError = false;
      let textAreaContent = '';
      if (commandType === 'tim') {
        if (this.textareaTim.trim() === '') {
          this.$notify.error({
            title: 'Error',
            message: 'El campo de TIM no puede estar vacío',
          });
          withError = true;
        } else {
          textAreaContent = this.textareaTim.trim();
        }
      }
      if (commandType === 'add') {
        if (this.textareaAdd.trim() === '') {
          this.$notify.error({
            title: 'Error',
            message: 'El campo de SOC a AGREGAR no puede estar vacío',
          });
          withError = true;
        } else {
          textAreaContent = this.textareaAdd.trim();
        }
      }
      if (commandType === 'del') {
        if (this.textareaDel.trim() === '') {
          this.$notify.error({
            title: 'Error',
            message: 'El campo de SOC a ELIMINAR no puede estar vacío',
          });
          withError = true;
        } else {
          textAreaContent = this.textareaDel.trim();
        }
      }
      if (withError === false) {
        if (textAreaContent !== '') {
          let orders;
          const ordersToNumbersTim = [];
          if (textAreaContent.indexOf(', ') !== -1) {
            orders = textAreaContent.split(', ');
          } else if (textAreaContent.indexOf('\n' !== -1)) {
            orders = textAreaContent.split('\n');
          } else if (textAreaContent.indexOf('\r' !== -1)) {
            orders = textAreaContent.split('\r');
          }
          orders.filter(e => e !== '').forEach((orderStringNumber) => {
            if (this.validateNumber(orderStringNumber.trim())) {
              ordersToNumbersTim.push(parseInt(orderStringNumber, 10));
            } else {
              ordersError.push(orderStringNumber);
            }
          });
          if (commandType === 'tim') {
            this.ordersToTim = ordersToNumbersTim;
            this.routeModify();
          }
          if (commandType === 'add' || commandType === 'del') {
            this.ordersToTim = ordersToNumbersTim;
            this.routeModAddDel(commandType);
          }
        }
        if (ordersError.length > 0) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: `El formato de las siguientes subordenes es incorrecto: ${ordersError.join(', ')}`,
          });
        } else {
          // eslint-disable-next-line
          if (this.ordersToAdd.length < 1 && this.ordersToDelete.length < 1) {
            this.$message({
              message: 'TIM contiene las mismas SOC de la ruta, no es necesario modificar Ruta',
              type: 'warning',
              duration: 8000,
            });
            this.cleanOrdersTo();
            this.cleanTextArea();
          } else {
            this.dialog.checkOrder = true;
          }
        }
      }
    },
    addOrderSoc() {
      this.loadingMod = true;
      this.dialog.checkOrder = false;
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'planning',
        flow: 'route_editing',
        action: 'route_update_requested',
        status: 'attempt',
        context: {
          tracing_id: this.idTracing,
          route_id: this.idRouteModSoc,
          source: 'planning_edit_routes',
          add_suborders: this.ordersToAdd.length,
          remove_suborders: this.ordersToDelete.length,
        },
      });
      this.ordersToAdd.forEach((el) => {
        this.ordersToEdit.add_suborders.push(el);
      });
      this.ordersToDelete.forEach((el) => {
        this.ordersToEdit.remove_suborders.push(el);
      });
      apiRequest(
        {
          module: 'planning',
          service: 'addanddelete_suborders',
          pathparam: { id: this.idRouteModSoc },
          params: this.ordersToEdit,
        },
      ).then((res) => {
        this.ordersToEdit.add_suborders = [];
        this.ordersToEdit.remove_suborders = [];
        this.resDataTim(res);
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing',
          action: 'route_update_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: this.idTracing,
            route_id: this.idRouteModSoc,
            source: 'planning_edit_routes',
            add_success: res.data.add_success ? res.data.add_success.length : 0,
            remove_success: res.data.remove_success ? res.data.remove_success.length : 0,
          },
        });
        this.searchTracing(this.idTracing);
        this.loadingMod = false;
      }).catch((error) => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing',
          action: 'route_update_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: this.idTracing,
            route_id: this.idRouteModSoc,
            source: 'planning_edit_routes',
            error_status: error.response ? error.response.status : null,
          },
        });
        if (error.response) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: error.response.data.message,
          });
        }
        // this.property.vehicle.patent = this.oldValue;
        this.loadingMod = false;
      });
      this.cleanTextArea();
    },
    cleanTextArea() {
      this.textareaTim = '';
      this.textareaAdd = '';
      this.textareaDel = '';
    },
    cleanOrdersTo() {
      this.ordersToAdd = [];
      this.ordersToDelete = [];
      this.ordersToTim = [];
    },
    validateNumber(number) {
      if (number === undefined || number === null) {
        return true;
      }
      if (/(^[0-9]{8,16}$)/.test(number)) {
        return true;
      }
      return false;
    },
    routeModify() {
      for (let i = 0; i < this.ordersToTim.length; i += 1) {
        const found = this.subOrderList.some(item => item.code === this.ordersToTim[i]);
        if (found === false) this.ordersToAdd.push(this.ordersToTim[i]);
      }
      for (let i = 0; i < this.subOrderList.length; i += 1) {
        const found = this.ordersToTim.some(item => item === this.subOrderList[i].code);
        if (found === false) this.ordersToDelete.push(this.subOrderList[i].code);
      }
    },
    routeModAddDel(commandType) {
      if (commandType === 'add') {
        for (let i = 0; i < this.ordersToTim.length; i += 1) {
          this.ordersToAdd.push(this.ordersToTim[i]);
        }
      }
      if (commandType === 'del') {
        for (let i = 0; i < this.ordersToTim.length; i += 1) {
          this.ordersToDelete.push(this.ordersToTim[i]);
        }
      }
    },
    resDataTim(res) {
      this.resultMod = true;
      if (res.data.add_suborders) {
        // eslint-disable-next-line
        if (res.data.add_suborders['not_found']) {
          this.notFoundAdd = res.data.add_suborders.not_found;
          this.nfAdd = 'OK';
        } else {
          this.notFoundAdd = [];
        }
        // eslint-disable-next-line
        if (res.data.add_suborders['is_in_other_route']) {
          this.addFailOtherRoutes = res.data.add_suborders.is_in_other_route;
          this.orAdd = 'OK';
        } else {
          this.addFailOtherRoutes = [];
        }
        // eslint-disable-next-line
        if (res.data.add_suborders['already_in_route']) {
          this.addAlreadyInRoute = res.data.add_suborders.already_in_route;
          this.airAdd = 'OK';
        } else {
          this.addAlreadyInRoute = [];
        }
      }
      if (res.data.remove_suborders) {
        // eslint-disable-next-line
        if (res.data.remove_suborders['not_found']) {
          this.notFoundDelete = res.data.remove_suborders.not_found;
          this.ntRem = 'OK';
        } else {
          this.notFoundDelete = [];
        }
        // eslint-disable-next-line
        if (res.data.remove_suborders['is_in_other_route']) {
          this.deleteFailOtherRoutes = res.data.remove_suborders.is_in_other_route;
          this.iorRem = 'OK';
        } else {
          this.deleteFailOtherRoutes = [];
        }
      }
      if (Array.isArray(res.data.add_success)) {
        this.addSuccess = res.data.add_success;
        this.addOK = 'OK';
      } else {
        this.addSuccess = null;
      }
      if (Array.isArray(res.data.remove_success)) {
        this.deleteSuccess = res.data.remove_success;
        this.remOK = 'OK';
      } else {
        this.deleteSuccess = null;
      }
      this.totalSocTim = this.ordersToTim.length;
    },
    cancelModSoc() {
      this.dialog.checkOrder = false;
      this.dialogEditSoc = false;
      this.cleanTextArea();
      this.cleanOrdersTo();
    },
    closeDialogTabs() {
      this.cleanTextArea();
    },
  },
  created() {
    this.searchTracing(this.idTracing); // Carga todas las rutas!!
    const self = this;
    if (window.addEventListener) {
      window.addEventListener('storage', geoUpdateHandlerEditRoutes(
        (code) => {
          const indx = self.selectedMarkId.findIndex(val => val.id === code);
          self.selectedMarkId[indx].geo_states_id = 6;
          self.newPage.close();
          this.searchTracing(this.idTracing);
        },
      ), false);
    }
  },
  destroyed() {
    const self = this;
    window.removeEventListener('storage', geoUpdateHandlerEditRoutes(
      (code) => {
        const index = self.selectedMarkId.findIndex(val => val.id === code);
        self.selectedMarkId[index].geo_states_id = 6;
      },
    ), false);
  },
};
</script>

<style lang="scss" scoped>
  .btnSearch{
    height: 40px;
  }
  .rowRoutePatent{
    display: table;
    margin-top: -20px;
    height:20px;
    margin-left: 30px;
    margin-bottom: 0px;
    text-align: left;
  }
  .el-icon-truck {
    margin-right: 10px;
    font-size: 20px;
    color: #c0c4cc;
    display: table-cell;
    vertical-align: middle;
  }
  .titleStyle {
    font-size: 11px;
    color: #707070;
    text-transform: uppercase;
    margin: 0 30px 0 0;
    font-weight: normal;
  }
  .titleStyleCV {
    font-size: 12px;
    color: #9B9B9B;
    text-transform: uppercase;
    margin: 15px 0 5px 50px;
    font-weight: normal;
    text-align: left;
  }
  .contentMap {
    width: 100%;
    height: 30vh !important;
  }
  .el-input__inner{
    width: 200px;
  }
  el-form el-form--inline{
    text-align: left;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 14px;
    text-align: left;
    margin: 0 0 1.2em;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .input {
    margin: 8px 0 16px 0;
  }
  .dialogText {
    width: 85%;
    margin: auto;
    .focus {
      display: block;
    }
  }
  .dialogItem {
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 20px;
    .focus {
      display: block;
    }
  }
  .btnBottom {
    margin-top: 10px;
    float: right;
  }
  .tableStyle {
    box-sizing: border-box;
    overflow: hidden;
  }
  .grey {
    background-color: #606266;
    align-self: flex-end;
    height: 40px;
  }
  .titleStyleNumRoutes {
    font-size: 13px;
    color: #AAD500;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 10px 0px;
  }
  .linkStyle {
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .dialogTitle {
    padding: 0 40px;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-edit {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-warning {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-truck {
      color: #AAD500;
      font-size: 1.2em;
      margin-right: 0.5em;
      padding-right: 5px;
      vertical-align: baseline;
    }
  }
  .dialogRec {
    padding: 0 40px;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 700;
    margin: 30px 0 0 0;
  }
  .dialogSub {
    padding: 10px 40px 0 0;
    text-align: left;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 500;
    margin-top: 0;
    .el-icon-circle-plus {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-remove {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-success {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .ordersListStyleDialog {
      font-size: 11px;
      text-align: left;
    }
    .dialogTotalTim {
      padding: 10px 40px 0 0;
      text-align: center;
      font-size: 1em;
      text-transform: uppercase;
      font-weight: 800;
      margin-top: 0;
    }
  }
  .dialogError {
    padding: 10px 40px 0 0px;
    text-align: left;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-error {
      color: #f4511e;
      font-size: 1.2em;
      margin: 0 0.5em 0 0;
    }
  }
  .totalItemTim{
    color: white;
    font-size: 10px;
    background: #F5A623;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    text-align: center;
    width: 2.4em;
  }
  .totalItemTimSuss{
    color: white;
    font-size: 12px;
    background: #AAD500;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    margin-top: 5px;
    text-align: center;
    width: 2.4em;
  }
  .ordersListStyleDialog{
    margin-left: 10px;
  }
  .dialogItemSuss{
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 30px;
    .focus {
      display: block;
    }
  }
  .clickeable {
    font-size: 7px;
    padding-top: 1px;
    margin-right: 3px;
    height: 23px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
  }
  .clickeable:hover {
    color: #AAD500;
    animation: none;
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  td {
    padding: 2px 0px !important;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -2px;
  }
  .spCla {
    font-size: 10px;
    color: #707070;
    vertical-align: middle;
    margin-left: 6px;
  }

  .rotate-1 {
    webkit-animation: rotating 5s linear infinite;
    animation: rotating 5s linear infinite;
  }

  .el-icon-refresh-right {
    padding: 3px;
    color: white;
    border-radius: 50%;
    background-color: #09558f;
  }

  .refresh-send {
    font-size: 15px;
    color: #AAD500;
    background-color: transparent;
  }

</style>
